import { useRef } from "react"
import { FlowDesigner } from "@/components/flow/flow"
import { useParams } from "react-router-dom"
import { app } from "@/lib/app"


export function Agent() {
  const p = useParams()
  // FlowDesigner loads its agent once on mount, so a different agent needs a fresh one.
  // A new agent getting its id on first save is the same canvas, so that keeps it
  const prevId = useRef(p.id)
  const generation = useRef(0)
  if (p.id !== prevId.current) {
    // Saving sets the agent's id before moving to /agent/<id>; any other move is a different agent
    const savedHere = prevId.current === "new" && String(app.agent?.id ?? "") === p.id
    if (!savedHere) generation.current++
    prevId.current = p.id
  }
  return <FlowDesigner key={generation.current} id={p.id} />
}
